import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { PieChart, Pie, Sector, Cell } from 'recharts';

import * as commonVar from 'libs/commonVar';

import { Icon, Image } from 'semantic-ui-react';
import { IconButton } from 'material-ui';

import { Loading } from 'components';

import styles from './TargetDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const openStatus = {
  attach: false,
  phishing: false
};

class TargetDetailExamChart extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  onToggleChart = detailType => {
    openStatus[detailType] = !openStatus[detailType];
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      // 훈련 이력
      targetExam,
      detailType
    } = this.props;

    const chartData = targetExam.get('chartData');
    const totalExam = chartData[detailType + 'Target'];
    const infectionPercent =
      !!chartData && chartData[detailType + 'Infection']
        ? Number((chartData[detailType + 'Infection'] / totalExam * 100).toFixed())
        : 0;
    const infectionFileArray = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: 100 - infectionPercent,
        percent: 100 - infectionPercent
      },
      {
        name: 'infection',
        color: '#db2828',
        value: infectionPercent,
        percent: infectionPercent
      }
    ];
    const textData = {
      total: {
        title: defineMessages(formatMessage({ id: 'ExamHeader_4', defaultMessage: '전체 훈련' })),
        down: defineMessages(formatMessage({ id: 'TargetDetail_38', defaultMessage: '다운 / 피싱 접속' })),
        infection: defineMessages(formatMessage({ id: 'TargetDetail_39', defaultMessage: '감염 / 정보 유출' })),
        chart: defineMessages(formatMessage({ id: 'ExamDetail_55', defaultMessage: '감염/유출율' }))
      },
      attach: {
        title: defineMessages(formatMessage({ id: 'ExamDetail_56', defaultMessage: '첨부 훈련' })),
        down: defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' })),
        infection: defineMessages(formatMessage({ id: 'TargetDetail_12', defaultMessage: '감염' })),
        chart: defineMessages(formatMessage({ id: 'CtExamTemplateList_2', defaultMessage: '감염율' }))
      },
      phishing: {
        title: defineMessages(formatMessage({ id: 'ExamDetail_57', defaultMessage: '피싱 훈련' })),
        down: defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' })),
        infection: defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' })),
        chart: defineMessages(formatMessage({ id: 'CtExamTemplateList_1', defaultMessage: '유출율' }))
      }
    };
    const curText = textData[detailType];

    return (
      <div className={cx('chartData', { total: detailType === 'total' })}>
        <div className={cx('chartData-title')}>
          {curText.title}
          {detailType !== 'total' && (
            <IconButton
              color="primary"
              className={cx('bt-toggleView')}
              onClick={e => {
                e.stopPropagation();
                this.onToggleChart(detailType);
              }}>
              <Image src={openStatus[detailType] ? '/img/target/ico_close.png' : '/img/target/ico_open.png'} />
            </IconButton>
          )}
        </div>
        {(detailType === 'total' || openStatus[detailType]) && (
          <div className={cx('chartData-inner')}>
            <div className={cx('chartData-content-area')}>
              <div className={cx('chartData-line')}>
                <div className={cx('chartData-icon brand')} />
                <div className={cx('chartData-each-title')}>
                  {defineMessages(formatMessage({ id: 'TargetDetail_31', defaultMessage: '총 훈련' }))}
                </div>
                <div className={cx('chartData-content')}>
                  {totalExam + ' '}
                  {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                </div>
              </div>
              <div className={cx('chartData-line')}>
                <div className={cx('chartData-icon orange')} />
                <div className={cx('chartData-each-title')}>
                  {defineMessages(formatMessage({ id: 'TargetDetail_11', defaultMessage: '열람' }))}
                </div>
                <div className={cx('chartData-content')}>
                  {chartData[detailType + 'Read'] + ' '}
                  {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                </div>
              </div>
              <div className={cx('chartData-line')}>
                <div className={cx('chartData-icon down')} />
                <div className={cx('chartData-each-title')}>{curText.down}</div>
                <div className={cx('chartData-content')}>
                  {chartData[detailType + 'Download'] + ' '}
                  {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                </div>
              </div>
              <div className={cx('chartData-line')}>
                <div className={cx('chartData-icon red')} />
                <div className={cx('chartData-each-title')}>{curText.infection}</div>
                <div className={cx('chartData-content')}>
                  {chartData[detailType + 'Infection'] + ' '}
                  {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                </div>
              </div>
              {detailType !== 'phishing' && (
                <div className={cx('chartData-line-sub')}>
                  <div className={cx('chartData-each-title')}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_33', defaultMessage: '감염 PC' }))}
                  </div>
                  <div className={cx('chartData-content')}>
                    {chartData[detailType + 'InfectionPc'] + ' '}
                    {defineMessages(formatMessage({ id: 'ExamDetail_17', defaultMessage: '대' }))}
                  </div>
                </div>
              )}
              {detailType !== 'phishing' && (
                <div className={cx('chartData-line')}>
                  <div className={cx('chartData-icon cure')} />
                  <div className={cx('chartData-each-title')}>
                    {defineMessages(formatMessage({ id: 'CtExamChart_7', defaultMessage: '치료' }))}
                  </div>
                  <div className={cx('chartData-content')}>
                    {chartData[detailType + 'Cure'] + ' '}
                    {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                  </div>
                </div>
              )}
              {commonVar.isDeclare === 1 && (
                <div className={cx('chartData-line')}>
                  <div className={cx('chartData-icon declare')} />
                  <div className={cx('chartData-each-title')}>
                    {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                  </div>
                  <div className={cx('chartData-content')}>
                    {chartData[detailType + 'Declare'] + ' '}
                    {defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' }))}
                  </div>
                </div>
              )}
            </div>
            <div className={cx('chartData-chart-area')}>
              {/* 악성 파일 감염율 이미지 넣기 */}
              <div className={cx('infectionChart-icon')}>
                <Image src="/img/exam/chart/all_danger.png" />
              </div>
              <PieChart width={120} height={120}>
                <Pie
                  dataKey="percent"
                  data={[
                    {
                      name: 'background',
                      percent: 100
                    }
                  ]}
                  cx={55}
                  cy={55}
                  innerRadius={47}
                  outerRadius={57}
                  startAngle={90}
                  endAngle={450}
                  paddingAngle={0}>
                  <Cell fill="#e6e6e6" />
                </Pie>
                <Pie
                  dataKey="percent"
                  data={infectionFileArray}
                  cx={55}
                  cy={55}
                  innerRadius={47}
                  outerRadius={57}
                  startAngle={90}
                  endAngle={450}
                  paddingAngle={0}
                  activeIndex={0}
                  activeShape={e => {
                    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, value } = e;
                    return (
                      <g>
                        {/* 그라데이션 효과 */}
                        <defs>
                          <linearGradient id="db2828" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#ff6c00" />
                            <stop offset="100%" stopColor="#ff0b72" />
                          </linearGradient>
                        </defs>
                        <Sector
                          cx={cx}
                          cy={cy}
                          innerRadius={innerRadius}
                          outerRadius={outerRadius}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          fill="rgb(230,230,230)"
                        />
                        {/* 차트의 확장 처리 */}
                        <Sector
                          cx={cx}
                          cy={cy}
                          startAngle={startAngle}
                          endAngle={endAngle}
                          innerRadius={outerRadius}
                          outerRadius={outerRadius}
                          fill={fill}
                          cornerRadius={10}
                        />
                      </g>
                    );
                  }}>
                  {/* cell 안에 그라데이션 효과 */}
                  {infectionFileArray.map((entry, index) => (
                    <Cell cornerRadius={10} key={index} fill={'url(' + entry.color + ')'} />
                  ))}
                </Pie>
              </PieChart>
              <div className={cx('infectionChart-text')}>
                <div className={cx('infectionChart-text-1')}>{curText.chart}</div>
                <div className={cx('infectionChart-text-2')}>
                  <span className={cx('value')}>{infectionPercent}</span>
                  <span className={cx('ea')}>{'%'}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(TargetDetailExamChart);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetDetailExamChart.js